import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions, selectors } from './loyalty-offers.slice';

export const useLoyaltyOffers = () => {
  const dispatch = useDispatch();

  const loyaltyOffersRetrievedPages = useSelector(
    selectors.selectRetrievedPages,
  );
  const loyaltyOffersHasMore = useSelector(selectors.selectHasMore);
  const loyaltyOffersLoading = useSelector(selectors.selectLoading);

  const fetchLoyaltyOffers = useCallback(
    params => dispatch(actions.fetchLoyaltyOffers(params)),
    [dispatch],
  );
  const removeOneOffer = useCallback(
    id => dispatch(actions.removeOne(id)),
    [dispatch],
  );

  const upsertManyLoyaltyOffers = useCallback(
    offers => dispatch(actions.upsertMany(offers)),
    [dispatch],
  );
  const deleteLoyaltyOffer = useCallback(
    id => dispatch(actions.deleteLoyaltyOffer({ id })),
    [dispatch],
  );
  const updateLoyaltyOfferStatus = useCallback(
    (id, status) => dispatch(actions.updateLoyaltyOfferStatus({ id, status })),
    [dispatch],
  );

  return {
    fetchLoyaltyOffers,
    removeOneOffer,
    upsertManyLoyaltyOffers,
    updateLoyaltyOfferStatus,
    deleteLoyaltyOffer,
    loyaltyOffersRetrievedPages,
    loyaltyOffersHasMore,
    offersLoading: loyaltyOffersLoading,
  };
};
